import DCData from './dcdata.js';

var SheetData = {  
  load : null,
	parse : null, 
  sheetData : [], 
};

// Callback function from old skool Google Spreadsheet API 
// gets data and parses it into SheetData.sheetData
// - no longer used, for reference only
SheetData.load = function(data, callback) {
		const copyKeys = ['chtr','twc','twchi','bhn','section','type','offertype','desc','product','symbol','tip'];
		const textKey = 'legal';	
		const textRe = RegExp(""+textKey+":(.+?)$");
    //console.log(data);
    if (data && data.feed && data.feed.entry){
      data.feed.entry.forEach ( function(entry) {
        //console.log(entry);
        if(entry.title && entry.title.$t && entry.content){
          let title = entry.title.$t;
          let vals = {};
					let re, part; 
          if (entry.content.$t) {
            let content = entry.content.$t.toString().trim().replace(/(\r\n|\n|\r)/gm,""); 
            //console.log(content);
						
						// get content for each copyKey 
            copyKeys.forEach(function(key){
							let re = RegExp(""+key+":(.+?)(,|$)");
							let part = content.match(re);
							//console.log(key, part);
							if (part && part[1]) {
								vals[key] = part[1].trim(); 
								vals['key'] = title;
							}
            });
						// get text content (last col)
						let part = content.match(textRe);
						//console.log(vals['key'], part)
						if (part && part[1]) {
							vals[textKey] = part[1].trim();
						}
						//console.log(vals);
          }
          SheetData.sheetData.push(vals);
        };
      });
    }
		
		//console.log(SheetData.sheetData);
		SheetData.parse(callback);
};

// * parse sheet values in to dcData 
SheetData.parse = function(callback) {
	const companyKeys = ['chtr','twc','twchi','bhn'];
	const dataKeys = ['key', 'section','type','offertype','desc','product','symbol','tip'];
	const textKey = 'legal';		
	
	const sheetData = SheetData.sheetData;
	//console.log(sheetData);
	if (sheetData.length == 0 ) {
		console.log('ERROR: No sheetData!');
		return;
	}
	//let out = {};
	let out = new DCData;
	
	sheetData.forEach((row) => {
		if (!out[row.section]) {
			out[row.section] = [];
		}
		
		if (row.desc && row.legal) {
			//console.log('sheetData', row);
			let data = {}
			companyKeys.forEach((ckey) => {
				if (row[ckey] && row[ckey].trim()!="") {
					data[ckey] = true; 
				}
			});
			dataKeys.forEach((dkey) => {
				if (row[dkey]) {
					data[dkey] = row[dkey];
				}
			});
			if (row[textKey]) {
				data['copy'] = row[textKey];
			}
			out[row.section].push(data);
		}	else {
			console.log('missing data?', row);
		}
		
	});
	console.log(out);	
	//DisclaimerApp.setData(out);
	callback(out);
};

export default SheetData;


